export const API_PATH = '/api';

export const SIGNUP_PATH = 'signup';
